<div class="sot-request-history seed-return-add-prod">
  <div>
    <h3 class="xs-pl-0 margin-l20">
      Request History
    </h3>
    <div class="margin-l20 font-14">
      Below is a brief history of this request.
    </div>
  </div>
  <hr />
  <div class="prod-top-sec margin-b20">
    <div class="form-sec">
      <div class="row margin-r0">
        <div class="col-md-4 font-16">
          <div class="row">
            <div class="col-md-4">
              Request Number:
            </div>
            <div class="col-md-8">
              {{sotRequestNumber}}
            </div>
          </div>
          <div class="row" *ngIf="isFromAccess">
            <div class="col-md-4">
              Requested By:
            </div>
            <div class="col-md-8">
              {{requestedBy}}
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              Creation Date:
            </div>
            <div class="col-md-8">
              {{creationDate| date:'MM/dd/yyyy'}}
            </div>
          </div>
        </div>
        <div class="col-md-4 font-16">
          <div class="row" *ngIf="isToAccess">
            <div class="col-md-4">
              Approved By:
            </div>
            <div class="col-md-8">
              {{ isrequestStatus ? '' : approvedBy }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              Approval Date:
            </div>
            <div class="col-md-8">
              {{ isrequestStatus ? '' : approvalDate| date:'MM/dd/yyyy'}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="tableContainer prodTableContainer sotRequestGrid" (window:resize)="onresize($event)">
        <table mat-table [dataSource]="requestHistoryDS" multiTemplateDataRows class="matTables productTable">

          <ng-container matColumnDef="Rejection Date">
            <th mat-header-cell *matHeaderCellDef class="text-center"> Rejection Date </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <span> {{element.rejectionDate| date:'MM/dd/yyyy'}} </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="Rejected By">
            <th mat-header-cell *matHeaderCellDef class="text-center"> Rejected By </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <span> {{ isToAccess && !isFromAccess ? '' : element.rejectedbyUser}} </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="Rejection Reason">
            <th mat-header-cell *matHeaderCellDef class="text-center"> Rejection Reason </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <span> {{element.rejectionComment}} </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="Resolution Date">
            <th mat-header-cell *matHeaderCellDef class="text-center"> Resolution Date </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <span> {{element.resolutionDate|  date: 'MM/dd/yyyy'}} </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="Resolved By">
            <th mat-header-cell *matHeaderCellDef class="text-center"> Resolved By </th>
            <td mat-cell *matCellDef="let element" class="text-center ">
              <span>
                {{isFromAccess && !isToAccess ? '' : element.resolvedByUser }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="Resolution Reason">
            <th mat-header-cell *matHeaderCellDef class="text-center"> Resolution Note </th>
            <td mat-cell *matCellDef="let element" class="text-center ">
              <span>
                {{element.resolutionComment}}
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'ineligible-row':(row?.displayMessage!=null),'active':(row?.IsProductSelected)}" (click)="keepRecords(row,true)"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
